import { Toaster as Sonner } from 'sonner';

import { useTheme } from '../../contexts/ThemeContext';

type ToasterProps = React.ComponentProps<typeof Sonner>;

/**
 * The portal's single transient-feedback channel. Mounted once in App.
 * Success/error/info toasts announce via sonner's built-in live region. Error
 * toasts take the destructive subtle tint; the others keep the card and tint
 * only their icon.
 */
const Toaster = ({ ...props }: ToasterProps) => {
  const { resolvedTheme } = useTheme();

  return (
    <Sonner
      theme={resolvedTheme}
      position="top-right"
      closeButton
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:bg-card group-[.toaster]:text-card-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg',
          description: 'group-[.toast]:text-muted-foreground',
          // Typed tints. The `group-[.toaster]:` prefix matches the base
          // class's specificity and these come later, so they win over bg-card.
          error:
            'group-[.toaster]:bg-destructive-subtle group-[.toaster]:text-destructive-emphasis group-[.toaster]:border-destructive-border [&_[data-icon]]:text-destructive-emphasis',
          success: '[&_[data-icon]]:text-success-emphasis',
          warning: '[&_[data-icon]]:text-warning-emphasis',
          info: '[&_[data-icon]]:text-info-emphasis',
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
